<template>
    <section class="hero header-has-background" :class="computedClass" :style="computedStyle">
        <div class="hero-body">
            <div class="container">
                <div class="mobile-logo mb-9">
                    <img :src="logo_url" alt="logo" contain class="brand-img">
                </div>
                <h1 class="cp-title-1 mb-3" :style="computedFont">
                    {{ configs.title }}
                </h1>
                <div v-if="configs.title" class="cp-line-lh" :style="computedColorPrimary"></div>
                <h2 v-if="configs.subtitle" class="is-size-3 mb-6 mt-3 is-family-secondary" :style="computedFont">
                    {{ configs.subtitle }}
                </h2>
                <p v-if="configs.description" class="size-description" :style="computedFont" style="max-width: 32rem">
                    {{ configs.description }}
                </p>
                <div class="is-hidden-tablet mobile-actions mt-6">
                    <button class="button mb-2" 
                        :style="computedButtonStyle"
                        @click="toRegister"
                    >Quero me cadastrar</button>
                    <button class="button"  
                            style="background: transparent"
                            :style="computedLogin"
                            :href="frontendUrl"
                            @click="toLogin"
                    >Entrar</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'HomeHeader',
    props: {
        configs: {
            type: Object,
            required: true,
        },
    },
    methods: {
        toRegister() {
            window.location = this.frontendUrl
        },
        toLogin() {
            window.location = this.frontendUrl
        },
    },
    computed: {
        computedClass() {
            return [
                this.configs.customClass,
                this.computedHeightClass,
            ]
        },

        ...mapGetters({
            font_color: 'company/font_color',
            primary_color   : 'company/primary_color',
            styles          : 'company/landing_page_colors',
            logo_url        : 'company/logo_url',
            frontendUrl     : 'company/frontend_domain',
        }),

        computedStyle() {
            return  {
                'background-image': `url("${this.configs.background_url}")`,
                'height'          : this.computedClass.filter(c => !!c).length ? '' : this.configs.customHeight,
            }
        },

        computedButtonStyle() {
            return {
                'border-color': this.styles.nav_background_color,
                'background-color': this.styles.nav_background_color,
                'color': this.styles.nav_font_color,
                'font-size': '1.125rem',
            }
        },

        computedLogin() {
            return {
                'color': this.styles.nav_background_color,
                'font-size': '1.125rem',
                'border-color': this.styles.nav_background_color,
                'background': this.styles.nav_font_color,
            }
        },

        computedColorPrimary() {
            return {
                'background-color': this.primary_color,
            }
        },

        computedFont() {
            return {
                'color': `${this.font_color} !important`,
            }
        },

        computedHeightClass() {
            let allowedHeights = ['small', 'medium', 'large', 'fullheight']
            return allowedHeights.includes(this.configs.height) ? `is-${this.configs.height}` : ''
        },
    },
}
</script>

<style lang="scss" scoped>
.header-has-background {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.size-description{
    font-size: 1.3125rem;
}
.brand-img {
      display: none;
    }

@media screen and (max-width: 768px) {
    .brand-img {
        display: inline;
        height: 100%;
        margin: 3rem auto;
        max-height: unset;

        max-height: 3.5rem;
    }
    .hero {
        opacity: .9;
    }
    .container {
        display: flex;
        flex-direction: column;

        text-align: center;
        justify-content: center;
        align-items: center;
    }
    .mobile-actions {
        display: flex;
        flex-direction: column;
    }
}
</style>